import React__default, { useContext } from 'react';

const SwanPopoverContext = /*#__PURE__*/ React__default.createContext({});
const SwanPopoverContextProvider = (props)=>{
    const { children, value } = props;
    return /*#__PURE__*/ React__default.createElement(SwanPopoverContext.Provider, {
        value: value
    }, children);
};
const useSwanPopover = ()=>useContext(SwanPopoverContext);

export { SwanPopoverContext, SwanPopoverContextProvider, useSwanPopover };
